import store from '../store'

export const processingApi = {
  show() {
    store.commit('SET_PROCESSING', true)
  },
  showModal(text, loaderHtml) {
    store.commit('SET_SHOW_MODAL', true)
    store.commit('SET_OVERLAY_TEXT', text)
    store.commit('SET_OVERLAY_LOADER', loaderHtml)
  },
  hideAll() {
    store.commit('SET_PROCESSING', false)
    store.commit('SET_SHOW_MODAL', false)
    store.commit('SET_OVERLAY_TEXT', '')
    store.commit('SET_OVERLAY_LOADER', '')
  }
}